export class UserInfo {
  userID: string;
  userType: EUserType;
  firstName: string;
  lastName: string;
  company: string;
  companyID: string;
  isCompanyAdministrator: boolean;
  email: string;
  isMailValidated: boolean;

  setUserInfos(decodedToken: any) {
    this.company = decodedToken.company;
    this.companyID = decodedToken.companyID;
    this.firstName = decodedToken.firstName;
    this.lastName = decodedToken.lastName;
    this.userID = decodedToken.userID;
    this.userType = Number.parseInt(decodedToken.userType, 10);
    this.isCompanyAdministrator = decodedToken.isCompanyAdministrator === "true";
  }
}

export enum EUserType {
  CUSTOMER = 1,
  CARRIER,
  SUPPLIER,
  ADMIN,
  SYSTEM
}
